import { hbs } from 'ember-cli-htmlbars';
export default hbs("{{page-title \"Users\"}}\n\n<Settings::SubuserList @subusers={{filter-by \"isNew\" false @model}} />\n{{outlet}}")